module.exports = __webpack_public_path__ + "static/media/logo1.68d02a2d.webp";